import { render, staticRenderFns } from "./secondAuthentication.vue?vue&type=template&id=5df4713b&scoped=true&"
import script from "./secondAuthentication.vue?vue&type=script&lang=js&"
export * from "./secondAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./secondAuthentication.vue?vue&type=style&index=0&id=5df4713b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4713b",
  null
  
)

export default component.exports